
  <div class="col-12">
    <div class="table-responsive border rounded">
      <table class="table table-sm table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>MountPoint</th>
            <th>Format</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mountPoint of pagedMountPoints"
              (click)="selectMountPoint(mountPoint)"
              [class.table-active]="selectedMountPoint === mountPoint"
              style="cursor:pointer;">
            <td>{{ mountPoint.stMountPoint }}</td>
            <td>{{ mountPoint.stFormat }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div><strong>Mountpoints:</strong> {{ (currentPage-1)*pageSize + 1 }} - {{ Math.min(currentPage*pageSize, user?.mountPoints?.length || 0) }} / {{ user?.mountPoints?.length || 0 }}</div>
      <div class="btn-toolbar" role="toolbar" aria-label="pagination">
        <div class="btn-group me-2" role="group" aria-label="first-prev">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goFirst()" [disabled]="currentPage === 1">« First</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goPrev()" [disabled]="currentPage === 1">‹ Prev</button>
        </div>
        <div class="btn-group me-2" role="group" aria-label="pages">
          <button *ngFor="let p of pageWindow" type="button"
                  class="btn btn-sm"
                  [ngClass]="{'btn-primary': p === currentPage, 'btn-outline-secondary': p !== currentPage}"
                  (click)="goToPage(p)">{{ p }}</button>
        </div>
        <div class="btn-group" role="group" aria-label="next-last">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goNext()" [disabled]="currentPage === totalPages">Next ›</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goLast()" [disabled]="currentPage === totalPages">Last »</button>
        </div>
      </div>
    </div>
  </div>




  
